// extracted by mini-css-extract-plugin
export default {"container":"style_container__5ml2A","title":"style_title__j6klM","desc":"style_desc__lpATW"};